import BaseComponent from "../BaseComponent";
import PropTypes from "prop-types";
import Accordion from "@mui/material/Accordion";

class AccordionLayout extends BaseComponent {

  render() {
    return <Accordion defaultExpanded={this.props.defaultExpanded} sx={{borderRadius: 1}}>
      {this.props.children}
    </Accordion>
  }
}

AccordionLayout.propTypes = {
  className: PropTypes.string, defaultExpanded: PropTypes.bool
}

export default AccordionLayout;